<!-- 
Contents of the SUMMARY tab of the scheduled job page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      user-guide-topic="administration-scheduled-jobs"
      module="scheduledJobs"
      nav-url="/scheduled-jobs/:id/summary"
    />
    <tabs :scheduled-job-id="scheduledJobId">
      <scheduled-job-summary-panel ref="panel" :scheduled-job-id="scheduledJobId" />
    </tabs>
  </div>
</template>

<script>
import ScheduledJobSummaryPanel from "@/components/scheduled-jobs/ScheduledJobSummaryPanel.vue";
import Tabs from "./Tabs.vue";
import scheduledJobMixins from "./mixins";

export default {
  name: "ScheduledJobSummary",
  components: { ScheduledJobSummaryPanel, Tabs },
  mixins: [scheduledJobMixins]
};
</script>
